module.exports = __webpack_public_path__ + "static/media/fifty_percent.d4c23361.png";